import { ArpMediaType } from '@arpeggi/shared'
import { getArpMedia, getArpMediaParentComponents, getOneArpMedia } from './v2/ArpMediaAPI'

///////////////////// Samples /////////////////////////////

export const getSongsAndStemsUsingSample = async (
  sampleId: number
): Promise<{ stemIDs: number[]; songIDs: number[] }> => {
  const data = await getArpMediaParentComponents(sampleId)

  return {
    stemIDs: data.filter((x) => x.type === ArpMediaType.STEM).map((stem) => stem.id),
    songIDs: data.filter((x) => x.type === ArpMediaType.SONG).map((song) => song.id)
  }
}

export const getIndexFromTokenId = async (tokenId: number, type: ArpMediaType) => {
  const { data } = await getArpMedia({ perPage: 1, type: [type], tokenId })

  return data?.[0].id ?? null
}

export const getSampleIndexFromOriginToken = async (tokenId: number): Promise<number> => {
  return getIndexFromTokenId(tokenId, ArpMediaType.SAMPLE)
}

///////////////////// Stems /////////////////////////////

export const getSongsUsingStem = async (stemID: number): Promise<{ songIDs: number[] }> => {
  const data = await getArpMediaParentComponents(stemID)

  return {
    songIDs: data.filter((x) => x.type === ArpMediaType.SONG).map((song) => song.id)
  }
}

export const getStemIndexFromOriginToken = async (tokenId: number): Promise<number> => {
  return getIndexFromTokenId(tokenId, ArpMediaType.STEM)
}

///////////////////// Songs /////////////////////////////

export const getSongIndexFromOriginToken = async (tokenId: number): Promise<number> => {
  return getIndexFromTokenId(tokenId, ArpMediaType.SONG)
}

///////////////////// General /////////////////////////////

/**
 * Given an arp media index, this will return the media type for it
 */
export const getMediaTypeFromIndex = async (
  index: number
): Promise<'sample' | 'stem' | 'song' | null> => {
  const arpMedia = await getOneArpMedia(index)

  return arpMedia.type
}
